
//
const trainingBookingPanel = document.querySelector('.training-booking-panel-dates');

//
if (trainingBookingPanel != null) {

    //
    let showAvailableDatesToggle = trainingBookingPanel.querySelector('.toggle-switch[data-action="showAvailableDates"] input');

    //handle the show/hide available dates toggle
    let toggleAvailableDates = () => {

        //
        let isChecked = showAvailableDatesToggle.checked;
        const selectedMethods = [];

        //
        trainingBookingPanel.querySelectorAll('.filter.selected').forEach(button => {
            const method = button.getAttribute('data-action').replace('Toggle', '');
            selectedMethods.push(method);
        });

        //
        if (selectedMethods.length === 0) {
            selectedMethods.push('eLearning', 'eClassroom', 'Classroom');
        }

        //
        trainingBookingPanel.querySelectorAll('.training-date').forEach(element => {

            //
            const method = element.getAttribute('data-deliveryMethod');

            //
            let placesAvailable = parseInt(element.getAttribute('data-placesavailable'));

            //
            if (isNaN(placesAvailable)) {
                placesAvailable = 0;
            }

            //only apply filtering to the selected methods
            if (selectedMethods.includes(method)) {
                if (isChecked && placesAvailable <= 0 ) {
                    element.style.display = 'none';
                } else {
                    element.style.display = 'flex';
                }
            }

        });

    };

    //event listener for the toggle checkbox
    if (showAvailableDatesToggle) {
        showAvailableDatesToggle.addEventListener('change', toggleAvailableDates);
        toggleAvailableDates();
    }

    //
    let eLearningState  = { name: 'eLearning',  button: trainingBookingPanel.querySelector('.filter[data-action="eLearningToggle"]:not(:disabled)'), state: false  };
    let eClassroomState = { name: 'eClassroom', button: trainingBookingPanel.querySelector('.filter[data-action="eClassroomToggle"]:not(:disabled)'), state: false };
    let classroomState  = { name: 'Classroom',  button: trainingBookingPanel.querySelector('.filter[data-action="ClassroomToggle"]:not(:disabled)'),  state: false };

    //
    if (eLearningState && eClassroomState && classroomState) {

        //
        let deliveryMethods = [eLearningState, eClassroomState, classroomState];
        deliveryMethods = deliveryMethods.filter(deliveryMethod => !(deliveryMethod.button === null));

        //
        deliveryMethods.forEach(deliveryMethod => {
            deliveryMethod.button.addEventListener('click', toggleState.bind(this, deliveryMethod));
        });

        //
        function toggleState(deliveryMethodState) {

            //
            let currentlyShowing = deliveryMethods.reduce((accumulated, value) => value.state ? accumulated + 1 : accumulated, 0);

            //
            if (deliveryMethodState.state == false || currentlyShowing > 1) {
                deliveryMethodState.state = !deliveryMethodState.state;
            }

            //
            deliveryMethods.forEach(deliveryMethod => {
                if (deliveryMethod.state == true) {
                    deliveryMethod.button.classList.add('selected');
                    trainingBookingPanel.querySelectorAll('.training-date[data-deliveryMethod="' + deliveryMethod.name + '"]').forEach(element => element.style.display = 'flex');
                } else {
                    deliveryMethod.button.classList.remove('selected');
                    trainingBookingPanel.querySelectorAll('.training-date[data-deliveryMethod="' + deliveryMethod.name + '"]').forEach(element => element.style.display = 'none');
                }
            });

            //call to filter available dates based on current selections
            toggleAvailableDates();
        }

    }

}
